import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function NovoPrazo() {
  const navigate = useNavigate();

  const [processos, setProcessos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  const [form, setForm] = useState({
    processo_id: "",
    cliente_id: "",
    descricao: "",
    data_prazo: "",
    visivel_cliente: true
  });

  useEffect(() => {
    api.get("/processos_list.php")
      .then(r => setProcessos(r.data))
      .catch(() => alert("Erro ao carregar processos"))
      .finally(() => setLoading(false));
  }, []);

  function handleSubmit(e) {
    e.preventDefault();

    if (!form.processo_id || !form.descricao || !form.data_prazo) {
      alert("Preencha todos os campos obrigatórios");
      return;
    }

    setSalvando(true);

    api.post("/prazo_create.php", form)
      .then(() => {
        alert("Prazo criado com sucesso");
        navigate("/app/admin/dashboard");
      })
      .catch(err => {
        console.error(err);
        alert("Erro ao salvar prazo");
      })
      .finally(() => setSalvando(false));
  }

  if (loading) {
    return (
      <AppLayout title="Novo Prazo">
        <p className="text-slate-400">Carregando processos…</p>
      </AppLayout>
    );
  }

  return (
    <AppLayout
      title="Novo Prazo"
      subtitle="Cadastro de prazo processual"
    >
      <form
        onSubmit={handleSubmit}
        className="max-w-xl space-y-4"
      >

        {/* PROCESSO */}
        <select
          required
          value={form.processo_id}
          onChange={e => {
            const p = processos.find(p => String(p.id) === e.target.value);
            if (!p) return;

            setForm(prev => ({
              ...prev,
              processo_id: p.id,
              cliente_id: p.cliente_id
            }));
          }}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        >
          <option value="">Selecione o processo</option>
          {processos.map(p => (
            <option key={p.id} value={p.id}>
              {p.numero || "Interno"} — {p.cliente}
            </option>
          ))}
        </select>

        {/* DESCRIÇÃO */}
        <input
          required
          placeholder="Descrição do prazo"
          value={form.descricao}
          onChange={e => setForm(prev => ({ ...prev, descricao: e.target.value }))}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        />

        {/* DATA */}
        <input
          type="date"
          required
          value={form.data_prazo}
          onChange={e => setForm(prev => ({ ...prev, data_prazo: e.target.value }))}
          className="w-full rounded-lg bg-[#0b0f19] border border-[#1f2937] p-3"
        />

        {/* VISIBILIDADE */}
        <label className="flex items-center gap-2 text-sm text-slate-300">
          <input
            type="checkbox"
            checked={form.visivel_cliente}
            onChange={e =>
              setForm(prev => ({
                ...prev,
                visivel_cliente: e.target.checked
              }))
            }
          />
          Visível para o cliente
        </label>

        {/* BOTÃO */}
        <button
          disabled={salvando}
          className="
            bg-blue-600 rounded-xl px-5 py-3 font-semibold
            hover:bg-blue-500 transition disabled:opacity-60
          "
        >
          {salvando ? "Salvando…" : "Salvar prazo"}
        </button>
      </form>
    </AppLayout>
  );
}
